import { render } from "./voiceDialog.vue?vue&type=template&id=5fa63efb&scoped=true"
import script from "./voiceDialog.vue?vue&type=script&lang=js"
export * from "./voiceDialog.vue?vue&type=script&lang=js"

import "./voiceDialog.vue?vue&type=style&index=0&id=5fa63efb&lang=scss"
import "./voiceDialog.vue?vue&type=style&index=1&id=5fa63efb&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa63efb"]])

export default __exports__